export const strings = {
    "message.welcome": "Welcome"
}